import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";
import { apiServices } from "./api";



export const store = configureStore({
  reducer: apiServices.reduce(
    (acc, api) => ({ ...acc, [api.reducerPath]: api.reducer }),
    { User: UserReducer }
  ),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiServices.map((api) => api.middleware)),

  devTools: process.env.NODE_ENV === "development",
});
